/**
 * ハンバーガーメニューの開閉機能
 */
export function headerMenuFunc() {
  const $overlay = $('.l-header-menu__overlay');
  const $container = $('.l-header-menu__container');
  const $closeBtn = $('.l-header-menu__close');
  const $toggleBtn = $('.l-header__toggle-button'); // ヘッダーのハンバーガーボタン
  const $body = $('body');

  /**
   * メニューを開く
   */
  function openMenu() {
    $overlay.addClass('is-active');
    $container.addClass('is-active');
    $body.addClass('menu-open');
    $toggleBtn.addClass('l-header__toggle-button--open');
  }

  /**
   * メニューを閉じる
   */
  function closeMenu() {
    $overlay.removeClass('is-active');
    $container.removeClass('is-active');
    $body.removeClass('menu-open');
    $toggleBtn.removeClass('l-header__toggle-button--open');
  }

  /**
   * ハンバーガーボタンクリック時
   */
  $toggleBtn.on('click', function () {
    if ($container.hasClass('is-active')) {
      closeMenu();
    } else {
      openMenu();
    }
  });

  /**
   * 閉じるボタンクリック時
   */
  $closeBtn.on('click', function () {
    closeMenu();
  });

  /**
   * オーバーレイクリック時
   */
  $overlay.on('click', function () {
    closeMenu();
  });

  /**
   * メニュー内のリンククリック時（SPのみ）
   */
  $('.l-header-menu__link, .l-header-menu__recruitment-btn').on(
    'click',
    function () {
      // ページ遷移するリンクの場合、メニューを閉じる
      closeMenu();
    }
  );

  /**
   * ESCキーでメニューを閉じる
   */
  $(document).on('keydown', function (e) {
    if (e.key === 'Escape' && $container.hasClass('is-active')) {
      closeMenu();
    }
  });

  /**
   * ウィンドウリサイズ時の処理
   */
  let resizeTimer;
  $(window).on('resize', function () {
    clearTimeout(resizeTimer);
    resizeTimer = setTimeout(function () {
      // PCサイズになったら自動的にメニューを閉じる
      if (window.innerWidth >= 768 && $container.hasClass('is-active')) {
        closeMenu();
      }
    }, 250);
  });
}
